module.exports = __webpack_public_path__ + "img/0-68.6b3b618c.jpg";